(ns frontend.view.modals.video.view
  (:require
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [ui.components.modal.view :as modal]))

(defonce modal-key :video-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [src]} props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     nil
     [:iframe
      {:src          src
       :width        "100%"
       :height       "100%"
       :allow        "autoplay; fullscreen"
       :frame-border 0}]
     nil]))
